export const THEMES: Record<string, string> = {
  default: 'flex px-4 py-3 text-grey-0 text-sm font-semibold rounded-xl hover:bg-grey-700 w-full',
  secondary: 'px-5 py-2.5 bg text-grey-100 border border-solid border-opacity-20 bg-opacity-10   rounded-xl',
  third: 'flex justify-start text-left px-4 py-3 text-grey-0 text-sm font-semibold bg-grey-700 rounded-xl hover:bg-opacity-10',
  four: 'flex items-center gap-2 px-4 py-3 text-grey-0 text-sm font-semibold bg-primary-500 rounded-xl hover:bg-primary-400',
  five: 'flex items-center gap-2 px-4 py-3 text-grey-100 text-sm font-semibold bg-opacity-10 rounded-xl hover:bg-opacity-20'
};
